import type { Team } from '@cs-shot/battle-sim';

// static class strings (no dynamic `border-${x}` — Tailwind would purge those)
const CLASSES: Record<'text' | 'bg' | 'border', Record<Team, string>> = {
  text: { t: 'text-gold', ct: 'text-accent-blue' },
  bg: { t: 'bg-gold/15', ct: 'bg-accent-blue/15' },
  border: { t: 'border-gold', ct: 'border-accent-blue' },
};

/** Faction tint class (T → gold, CT → accent-blue) for a given Tailwind property. */
export const sideColor = (side: Team, kind: 'text' | 'bg' | 'border'): string => CLASSES[kind][side];
